import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import {
  confirmResetPasswordRequest,
  IConfirmResetPassRequest,
  IResetPassLinkRequest,
  IValidateTokenRequest,
  resetPassLinkRequest,
  validateTokenRequest,
} from '../services/resetPassword';

export const useResetPassword = () => {
  const { search } = useLocation();
  const resetPassword = async (email: IResetPassLinkRequest) => {
    await resetPassLinkRequest(email);
    return;
  };

  const validateToken = async (token: IValidateTokenRequest) => {
    const { valid } = await validateTokenRequest(token);
    return valid;
  };

  const confirm = async (credentials: IConfirmResetPassRequest) => {
    await confirmResetPasswordRequest(credentials);
    return;
  };

  const getToken = useCallback(() => {
    return Object.fromEntries(new URLSearchParams(search))?.token;
  }, [search]);

  return { resetPassword, validateToken, confirm, getToken };
};
